import NotFound from '@/views/common/NotFound.vue'
import Deny from '@/views/common/Deny.vue'
import ErrorFound from '@/views/common/Error.vue'
import Login from '@/views/common/Login.vue'
import NewPassword from '@/views/common/NewPassword.vue'

const commonRouters = (beforeEnter) => {
    return [
        {
            path: '*',
            meta: {
                public: true,
                layout: 'login'
            },
            redirect: {
                path: '/404'
            }
        },
        {
            name: 'NotFound',
            path: '/404',
            meta: {
                public: true,
                layout: 'login'
            },
            component: NotFound
        },
        {
            name: 'AccessDenied',
            path: '/403',
            meta: {
                public: true,
                layout: 'login'
            },
            component: Deny
        },
        {
            name: 'ServerError',
            path: '/500',
            meta: {
                public: true,
                layout: 'login'
            },
            component: ErrorFound
        },
        {
            beforeEnter: beforeEnter,
            name: 'Login',
            path: '/login',
            meta: {
                requiresAuth: false,
                layout: 'login'
            },
            component: Login
        },
        {
            beforeEnter: beforeEnter,
            name: 'NovaSenha',
            path: '/nova_senha',
            meta: {
                requiresAuth: true,
                layout: 'login'
            },
            component: NewPassword
        },
        {
            beforeEnter: beforeEnter,
            name: 'Home',
            path: '/',
            meta: {
                requiresAuth: false,
                layout: 'default'
            },
            redirect: '/demandas'
        }
    ]
}

export default commonRouters
